export default "__VITE_ASSET__6fcf1246__"